<template>
  <div class="logauditoria">
    <loader
      object="#df3e46"
      v-show="progress"
      color1="#0db9d3"
      color2="#fff01f"
      size="4"
      speed="2.4"
      bg="#C0C0C0"
      objectbg="#0d0c0d"
      opacity="50"
      name="circular"
    ></loader>
    <div class="container-fluid">
      <ol class="breadcrumb-arrow">
        <li>
          <a href="/home"><i class="fa fa-home"></i></a>
          <a href="/log">Logs</a>
        </li>
        <li class="active"><span>Auditoria</span></li>
      </ol>
    </div>
    <div class="container-fluid mt-2">
      <div class="card">
        <div class="card-body">
          <div class="row ml-0 mr-0 page-header-title">
            <div
              class="
                col-lg-2 col-sm-12
                pr-0
                pl-0
                d-none d-sm-block d-lg-block d-xl-block
              "
            >
              <h2 class="text-header txt-bloqueio">Logs de auditoria</h2>
            </div>

            <div class="col-lg-8 col-sm-12 text-center">
              <jw-pagination
                :items="logs"
                @changePage="onChangePage"
                pageSize = "20"
                :labels="customLabels"
                :styles="defaultStyles"
              ></jw-pagination>
            </div>

            <div
              class="col-lg-2 col-sm-12 nput-search pl-0 nput-group d-flex pr-0"
            >
              <div class="pd-print" id="imprimir">
                <li class="nav-item dropdown">
                  <a class="nav-link" data-toggle="dropdown" href="#">
                    <i class="fas fa-file-export"></i>
                  </a>
                  <div class="dropdown-menu dropdown-menu-right text-center">
                    <a
                      href="#"
                      @click="exportReport('PDF')"
                      class="dropdown-item"
                      title="Gerar PDF"
                    >
                      <div>
                        <i class="fa fa-file-pdf fa-2x text-danger mr-2"></i>
                        PDF
                      </div>
                    </a>
                    <a
                      href="#"
                      @click="exportReport('XLS')"
                      class="dropdown-item"
                      title="Gerar Excel"
                    >
                      <div>
                        <i class="fa fa-file-excel fa-2x text-success mr-2"></i>
                        XLS
                      </div>
                    </a>
                    <a
                      href="#"
                      @click="exportReport('TXT')"
                      class="dropdown-item"
                      title="Gerar TXT"
                    >
                      <div><i class="far fa-file-alt fa-2x mr-2"></i> TXT</div>
                    </a>
                  </div>
                </li>
              </div>
              <input
                class="input-pesquisa-imprimir inputiPad search-menu"
                placeholder="Pesquisar..."
                v-model="filtroTipo"
                @keyup="filtrarTipo"
              />
            </div>
          </div>
          <table class="table table-hover">
            <thead
              style="background-image: linear-gradient(to left, white, #f2f2f2)"
            >
              <tr>
                <th width="15%">Data/Hora</th>
                <th width="15%">Ação</th>
                <th width="20%">Funcionalidade</th>
                <th width="20%">Usuário</th>
                <th width="30%">Observação</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="log in pageOfItems" :key="log.id">
                <td>{{ log.dataHoraFmt }}</td>
                <td>{{ log.acao }}</td>
                <td>{{ log.funcionalidade }}</td>
                <td>{{ log.usuario }}</td>
                <td>{{ log.observacao }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import FileSaver from "file-saver";

const customLabels = {
  first: "<<",
  last: ">>",
  previous: "<",
  next: ">",
};

const defaultStyles = {
  ul: {
    margin: 0,
    padding: 0,
    display: "inline-block",
  },
  li: {
    listStyle: "none",
    display: "inline",
    textAlign: "center",
  },
  a: {
    cursor: "pointer",
    padding: "7px 7px",
    display: "block",
    float: "left",
  },
};

export default {
  components: {},
  created() {
    this.carregarLogs();
  },
  data() {
    return {
      pageOfItems: [],
      progress: true,
      logs: [],
      logsFiltro: [],
      filtroTipo: "",
      customLabels,
      defaultStyles,
    };
  },
  methods: {
    onChangePage(pageOfItems) {
      // update page of items
      this.pageOfItems = pageOfItems;
    },
    filtrarTipo() {
      if (this.filtroTipo === "") {
        this.logs = this.logsFiltro;
      } else {
        this.logs = this.logsFiltro.filter((item) => {
          return (
            item.acao.toUpperCase().indexOf(this.filtroTipo.toUpperCase()) >=
              0 ||
            item.funcionalidade
              .toUpperCase()
              .indexOf(this.filtroTipo.toUpperCase()) >= 0 ||
            item.usuario.toUpperCase().indexOf(this.filtroTipo.toUpperCase()) >=
              0 ||
            item.dataHoraFmt.indexOf(this.filtroTipo.toUpperCase()) >= 0 ||
            (item.observacao != null &&
              item.observacao
                .toUpperCase()
                .indexOf(this.filtroTipo.toUpperCase()) >= 0)
          );
        });
      }
    },
    carregarLogs() {
      this.$clubApi
        .get("/log")
        .then((response) => {
          this.logs = response.data.object;
          this.logsFiltro = response.data.object;
        })
        .catch((error) => {
          this.$toastr.error(error.response.data.msg);
        })
        .finally(() => {
          this.progress = false;
        });
    },
    exportReport(tipo) {
      this.progress = true;
      this.$clubApi
        .get("/log/report/" + tipo, {
          responseType: "blob",
        })
        .then((response) => {
          var nomeArquivoHeaders = response.headers["content-disposition"];
          var nomeArquivo = nomeArquivoHeaders;
          var contentType = response.headers["content-type"];
          var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
          var matches = filenameRegex.exec(nomeArquivoHeaders);
          nomeArquivo = matches[1].replace(/['"]/g, "");
          var blob = new Blob([response.data], {
            type: contentType,
          });
          FileSaver.saveAs(blob, nomeArquivo);
        })
        .catch((error) => {
          this.$toastr.error(error.response.data.msg);
        })
        .finally(() => {
          this.progress = false;
        });
    },
  },
};
</script>

<style scoped>
.container-fluid { padding-left: 10px !important; padding-right: 10px !important; }
</style>